var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ([51].indexOf(this.getUserRoleId)>-1)?_c('beneficiaryCases'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }